/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from '@angular/core';
import { Report, ReportUserType, Stage} from '../model';

@Injectable()
export class UserPersistenceService {
  tempUsers = new Map();

  persistReportAssignee(assignees: any): Report[] {
    this.tempUsers = new Map();
    if (assignees) {
      for (const s of assignees) {
        if (typeof s.ASSIGNEE === 'object' && s.ASSIGNEE['@id']) {
          this.tempUsers.set(s.ASSIGNEE['@id'], s.ASSIGNEE);
        }
      }

      for (const s of assignees){
        if (typeof s.ASSIGNEE !== 'object')
          s.ASSIGNEE = this.tempUsers.get(s.ASSIGNEE);
      }
    }

    return Report.parseArray(assignees);
  }

  persistReportUsers(data: any): Report {
    this.tempUsers = new Map();
    if (data.USERS) {
      for (const r in ReportUserType) {
        if (typeof r === 'string') {
          if (data.USERS[r]) {
            if (typeof data.USERS[r].USER === 'object')
              this.tempUsers.set(data.USERS[r].USER['@id'], data.USERS[r].USER);
          }
        }
      }

      for (const r in ReportUserType) {
        if (typeof r === 'string') {
          if (data.USERS[r]) {
            if (typeof data.USERS[r].USER !== 'object')
              data.USERS[r].USER = this.tempUsers.get(data.USERS[r].USER);
          }
        }
      }
    }

    if(data.REPORT_WATCHERS){
      let watchers = data.REPORT_WATCHERS.map(watcher => {
        if (typeof watcher === 'object') {
          this.tempUsers.set(watcher['@id'], watcher);
        }

        if(typeof watcher !== 'object'){
          watcher = this.tempUsers.get(watcher);
        }
        return watcher;
      });
      data.REPORT_WATCHERS = watchers;
    }

    if(data.ASSIGNEE){

      if (typeof data.ASSIGNEE === 'object')
        this.tempUsers.set(data.ASSIGNEE['@id'], data.ASSIGNEE);

      if (typeof data.ASSIGNEE !== 'object')
        data.ASSIGNEE = this.tempUsers.get(data.ASSIGNEE);
    }

    if (data.DELAYS){
      let delays = data.DELAYS.map(delay => {

        if (typeof delay.USER_START === 'object') {
          this.tempUsers.set(delay.USER_START['@id'], delay.USER_START);
        }

        if (typeof delay.USER_END === 'object') {
          if(delay.USER_END){
            this.tempUsers.set(delay.USER_END['@id'], delay.USER_END);
          }
        }

        if (typeof delay.USER_START !== 'object'){
          delay.USER_START = this.tempUsers.get(delay.USER_START);
        }

        if (typeof delay.USER_END !== 'object'){
          delay.USER_END = this.tempUsers.get(delay.USER_END);
        }

        return delay;
      });

      data.DELAYS = delays;
    }

    return Report.parse(data);
  }

  persistReportStageUserAndAssignee(stages: any): Stage[] {
    this.tempUsers = new Map();
    if (stages) {
      for (const s of stages) {
        if (s.HISTORY && s.HISTORY.length > 0) {
          for (const h of s.HISTORY) {
            if (typeof h.USER === 'object') {
              this.tempUsers.set(h.USER['@id'], h.USER);
            }

            if (typeof h.ASSIGNEE === 'object') {
              this.tempUsers.set(h.ASSIGNEE['@id'], h.ASSIGNEE);
            }
          }
        }
      }

      for (const s of stages) {
        if (s.HISTORY && s.HISTORY.length > 0) {
          for (const h of s.HISTORY) {
            if (h.USER)
              if (typeof h.USER !== 'object')
                h.USER = this.tempUsers.get(h.USER);

            if (h.ASSIGNEE)
              if (typeof h.ASSIGNEE !== 'object')
                h.ASSIGNEE = this.tempUsers.get(h.ASSIGNEE);
          }
        }

      }
    }

    return Stage.parseArray(stages);
  }
}
